export default class TextUtilities {

  public static DotDotDot = '…';
  public static RightArrow = '→';
  public static LeftArrow = '←';
  public static RightArrowDouble = '⇒';
  public static LeftArrowDouble = '⇐';
  
  public static truncate = function (str, length, ending): string {
    if (!str) {
      return '';
    }
    if (length === null) {
      length = 100;
    }
    if (ending === null) {
      ending = '...';   // DotDotDot
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  };
}
